export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BUSINESS = {
  name: "H.Elektronik",
  street: "Westring 37",
  city: "33334 Gütersloh",
  area: "Innenstadt",
  phoneDisplay: "01522 4760623",
  phoneHref: "tel:+4915224760623",
};

export const HOURS = [
  { days: "Montag – Freitag", time: "10:00 – 18:00 Uhr" },
  { days: "Samstag", time: "09:00 – 14:00 Uhr" },
  { days: "Sonntag", time: "Geschlossen" },
];

export const getOpenStatus = () => {
  const now = new Date();
  const day = now.getDay();
  const mins = now.getHours() * 60 + now.getMinutes();
  const ranges = {
    1: [600, 1080],
    2: [600, 1080],
    3: [600, 1080],
    4: [600, 1080],
    5: [600, 1080],
    6: [540, 840],
  };
  const r = ranges[day];
  const open = Boolean(r) && mins >= r[0] && mins < r[1];
  return { open, label: open ? "Jetzt geöffnet" : "Derzeit geschlossen" };
};

export const MARQUEE_ITEMS = [
  "Display-Tausch",
  "Akku-Service",
  "Wasserschaden",
  "Datenrettung",
  "Express-Reparatur Gütersloh",
  "Meisterqualität",
  "Transparente Festpreise",
];

export const SERVICES = [
  {
    number: "01",
    title: "Display-Reparatur & Glasaustausch",
    subtitle: "Gestochen scharfe OLED- & LCD-Panels",
    details:
      "Risse im Glas, schwarze Streifen oder Touchscreen ohne Funktion? Wir ersetzen Ihr Display innerhalb von 30–60 Minuten mit Markenbauteilen in Erstausrüsterqualität.",
    badge: "Express 30–60 Min",
    image:
      "https://images.unsplash.com/photo-1772831902679-3f41c106d7a2?auto=format&fit=crop&w=1000&q=80",
  },
  {
    number: "02",
    title: "Akku-Tausch & Kapazitätsanalyse",
    subtitle: "Maximale Laufzeit für Ihr Smartphone",
    details:
      "Schwindende Akkuleistung oder unerwartetes Ausschalten? Wir verbauen frische Hochleistungsakkus — inklusive Überlastungsschutz und vollständiger Kapazitätsprüfung.",
    badge: "100% Kapazität",
    image:
      "https://images.unsplash.com/photo-1611396000732-f8c9a933424f?auto=format&fit=crop&w=1000&q=80",
  },
  {
    number: "03",
    title: "Wasserschaden & Mikrolöten",
    subtitle: "Rettung für nasse & geschädigte Platinen",
    details:
      "Flüssigkeit eingedrungen? Durch professionelle Ultraschallreinigung und Mikrolöttechnik auf Chip-Ebene retten wir selbst vermeintliche Totalschäden.",
    badge: "Chip-Level Spezialist",
    image:
      "https://images.unsplash.com/photo-1588515603140-81bd9f7d1db0?auto=format&fit=crop&w=1000&q=80",
  },
  {
    number: "04",
    title: "Datenrettung & Software-Service",
    subtitle: "Fotos, Kontakte & Dokumente sichern",
    details:
      "Smartphone startet nicht mehr oder hängt in der Bootschleife? Wir sichern Ihre wertvollen Erinnerungen — vertraulich, zuverlässig und DSGVO-konform.",
    badge: "Vertraulich & sicher",
    image:
      "https://images.unsplash.com/photo-1617299516258-eb06985065ff?auto=format&fit=crop&w=1000&q=80",
  },
];

export const STEPS = [
  {
    step: "01",
    title: "Anfrage & Diagnose",
    desc: "Kommen Sie am Westring 37 vorbei oder rufen Sie uns an — wir prüfen den Schaden kostenfrei und nennen Ihnen sofort einen fairen Festpreis.",
  },
  {
    step: "02",
    title: "Präzisions-Reparatur",
    desc: "Nach Ihrer Freigabe reparieren wir Ihr Gerät mit Spezialwerkzeug und hochwertigen Ersatzteilen — meist noch am selben Tag.",
  },
  {
    step: "03",
    title: "Prüfung & Übergabe",
    desc: "Jedes Gerät durchläuft vor der Übergabe einen vollständigen Funktionstest. Sie erhalten Ihr Smartphone zurück — inklusive Garantie.",
  },
];

export const REVIEWS = [
  {
    name: "Markus T.",
    device: "iPhone 14 Pro — Display",
    text: "Display nach Sturz komplett zersplittert. Nach 45 Minuten war das iPhone wie neu — inklusive Top-Qualität und Garantie. Absolut professionell.",
  },
  {
    name: "Sandra K.",
    device: "Samsung Galaxy S23 — Akku",
    text: "Mein Akku hielt kaum noch einen halben Tag. Der Tausch ging super schnell und der Preis wurde vorher transparent genannt. Klare Empfehlung am Westring!",
  },
  {
    name: "Yusuf A.",
    device: "iPad — Wasserschaden",
    text: "Nach dem Wasserschaden dachte ich, alle Fotos wären weg. H.Elektronik hat das iPad und sämtliche Daten gerettet. Kompetent, ehrlich und schnell.",
  },
];

export const ISSUES = [
  "Display / Glas gebrochen",
  "Akku schwächelt",
  "Wasserschaden",
  "Ladebuchse defekt",
  "Software / Datenrettung",
  "Sonstiges",
];
